import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiIVideoGrid' })(
  ({ brandColors, breakpoints, type, typography }) => ({
    container: {
      marginLeft: typography.pxToRem(80),
      marginRight: typography.pxToRem(80),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [breakpoints.down(ScreenSize.LARGE)]: {
        alignItems: 'flex-start',
        margin: 0,
      },
    },
    largeVideoContainer: {
      borderRadius: typography.pxToRem(27),
      height: typography.pxToRem(432),
      width: typography.pxToRem(690),
      [breakpoints.down(ScreenSize.LARGE)]: {
        width: typography.pxToRem(514),
        height: typography.pxToRem(322),
      },
    },
    smallVideoContainer: {
      borderRadius: typography.pxToRem(17),
      height: typography.pxToRem(135),
      width: typography.pxToRem(215),
      [breakpoints.down(ScreenSize.LARGE)]: {
        width: typography.pxToRem(514),
        height: typography.pxToRem(322),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        width: typography.pxToRem(320),
        height: typography.pxToRem(209),
      },
      [breakpoints.down(350)]: {
        width: typography.pxToRem(250),
      },
    },
    smallVideo: {
      width: typography.pxToRem(215),
      marginLeft: typography.pxToRem(10),
      marginRight: typography.pxToRem(10),
      '&:first-child': {
        marginLeft: 0,
      },
      '&:last-child': {
        marginRight: 0,
      },
      [breakpoints.down(ScreenSize.LARGE)]: {
        width: typography.pxToRem(514),
        marginTop: typography.pxToRem(43),
        margin: 0,
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        width: typography.pxToRem(320),
      },
      [breakpoints.down(350)]: {
        width: typography.pxToRem(250),
      },
    },
    titleLarge: {
      ...type['20_regular'],
      marginTop: typography.pxToRem(25),
      marginBottom: typography.pxToRem(72),
    },
    titleSmall: {
      ...type['20_regular'],
      marginTop: typography.pxToRem(17),
      [breakpoints.down(ScreenSize.LARGE)]: {},
    },
    videoGroup: {
      flexDirection: 'row',
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      [breakpoints.down(ScreenSize.LARGE)]: {
        flexDirection: 'column',
      },
    },
    learnMoreText: {
      fontFamily: 'Roobert',
      fontSize: typography.pxToRem(18),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: typography.pxToRem(24) /* 133.333% */,
      letterSpacing: typography.pxToRem(0.18),
      marginLeft: typography.pxToRem(14),
      color: brandColors.heroBlue,
    },
    learnMore: {
      display: 'flex',
      alignItems: 'center',
    },
  })
);

export default useStyles;
